import { VehicleId } from '../common.model';

export interface DWTUrlParams {
  articleTabIdx: number;
  smVehicleId: VehicleId;
  smPage: number;
  smFilter: string;
  smReservation: boolean;
  showroomModel: string;
  showroomModelAdmin: string;
  showroomModelAdminAlias: string;
  showroomModelId: number;
  showroomCategoryTabIdx: number;
  showroomCategoryTabName: string;
  showroomCategoryTab: string;
  showroomTabIdx: number;
  tlpSalesOfferId: number;
  tlpStockId: number;
  tlpStockPage: number;
  tlpCarId: number;
  location: string;
  ratingTab: string;
  tabIndex: number;
  devShowLabels: boolean;
  devShowModules: boolean;
  devShowFormValue: boolean;
  devShowFormFieldInfo: boolean;
  campaignid: string;
  offerid: string;
  level1: string;
  level2: string;
  level3: string;
  ctatype: string;
  businessarea: string;
}

export type DWTUrlParamName = keyof DWTUrlParams;

export interface DWTModuleUrlParam<T> {
  name: DWTUrlParamName;
  parser: (s: string) => T;
  serializer?: (param: T) => string;
  dontTransformParamName?: boolean;
}

const handleUndefinedOrNullString =
  <T>(f: (s: string) => T) =>
  (s: string) =>
    ['undefined', 'null'].includes(s) ? undefined : f(s);

const stringParser = handleUndefinedOrNullString((s) => s);
const numberParser = handleUndefinedOrNullString((s) => Number.parseFloat(s));
const booleanParser = handleUndefinedOrNullString((s) => s.toLocaleLowerCase() === 'true');

export const dwtUrlParams: DWTModuleUrlParam<string | number | boolean | undefined>[] = [
  { name: 'smVehicleId', parser: numberParser },
  { name: 'smPage', parser: numberParser },
  { name: 'showroomModelId', parser: numberParser },
  { name: 'showroomModel', parser: stringParser },
  { name: 'showroomModelAdmin', parser: stringParser },
  { name: 'showroomModelAdminAlias', parser: stringParser },
  { name: 'showroomCategoryTabIdx', parser: numberParser },
  { name: 'showroomCategoryTabName', parser: stringParser },
  { name: 'showroomCategoryTab', parser: stringParser },
  { name: 'showroomTabIdx', parser: numberParser },
  { name: 'smFilter', parser: stringParser },
  { name: 'smReservation', parser: booleanParser },
  { name: 'tlpSalesOfferId', parser: numberParser },
  { name: 'tlpStockId', parser: numberParser },
  { name: 'tlpStockPage', parser: numberParser },
  { name: 'tlpCarId', parser: numberParser },
  { name: 'tabIndex', parser: numberParser },
  { name: 'location', parser: stringParser, dontTransformParamName: true },
  { name: 'ratingTab', parser: stringParser, dontTransformParamName: true },
  { name: 'devShowLabels', parser: booleanParser, dontTransformParamName: true },
  { name: 'devShowModules', parser: booleanParser, dontTransformParamName: true },
  { name: 'devShowFormValue', parser: booleanParser, dontTransformParamName: true },
  { name: 'devShowFormFieldInfo', parser: booleanParser, dontTransformParamName: true },
  { name: 'campaignid', parser: stringParser, dontTransformParamName: true },
  { name: 'offerid', parser: stringParser, dontTransformParamName: true },
  { name: 'level1', parser: stringParser, dontTransformParamName: true },
  { name: 'level2', parser: stringParser, dontTransformParamName: true },
  { name: 'level3', parser: stringParser, dontTransformParamName: true },
  { name: 'ctatype', parser: stringParser, dontTransformParamName: true },
  { name: 'businessarea', parser: stringParser, dontTransformParamName: true },
];

export const dwtUrlParamAliases: Partial<Record<DWTUrlParamName, string[]>> = {
  smPage: ['vacsPage'],
  smFilter: ['vacsFilter'],
  smVehicleId: ['vacsVehicleId'],
};
